import type {QRWifiInput} from '@Libraries/qr-code/qr-code.types';
import {QRWifiSecurity} from '@Libraries/qr-code/qr-code.types';
import type {QRFormProps} from '@Components/qr-code-generator/qr-code-generator.types';

export type QRWifiFormProps = QRFormProps<QRWifiInput>;

export const QR_WIFI_SECURITY_ORDER: QRWifiSecurity[] = [QRWifiSecurity.WPA, QRWifiSecurity.WEP, QRWifiSecurity.NONE];

export const QR_WIFI_SECURITY_BY_ID: Record<string, QRWifiSecurity> = {
  [QRWifiSecurity.WPA]: QRWifiSecurity.WPA,
  [QRWifiSecurity.WEP]: QRWifiSecurity.WEP,
  [QRWifiSecurity.NONE]: QRWifiSecurity.NONE,
};
